<template>
  <div class="settings px-4">
    <h2 class="main-title">{{ lang == "en" ? "Settings" : "Postavke" }}</h2>
    <div class="main-container">
      <v-card class="reset-password-container" elevation="0">
        <h5 class="mb-4">
          {{ lang == "en" ? "CHANGE PASSWORD" : "PROMENA LOZINKE" }}
        </h5>

        <div>
          <v-form ref="resetPasswordForm" v-model="validForm" lazy-validation>
            <v-text-field
              :label="lang == 'en' ? 'Old password' : 'Stara lozinka'"
              type="password"
              v-model="password.old"
              @keyup.enter="resetPassword()"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'New password' : 'Nova lozinka'"
              type="password"
              v-model="password.new"
              @keyup.enter="resetPassword()"
              :rules="passwordConfirmationRule"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="
                lang == 'en' ? 'Confirm new password' : 'Potvrdi novu lozinku'
              "
              type="password"
              v-model="password.newConfirm"
              @keyup.enter="resetPassword()"
              :rules="passwordConfirmationRule"
              outlined
              dense
            ></v-text-field>
            <v-btn
              elevation="0"
              color="text--white teal darken-2"
              block
              @click="resetPassword()"
            >
              {{ lang == "en" ? "RESET PASSWORD" : "RESETUJ LOZINKU" }}
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Settings",
  data() {
    return {
      validForm: false,
      password: {
        old: "",
        new: "",
        newConfirm: "",
      },
    };
  },
  computed: {
    ...mapState(["lang", "IDcompany"]),
    ...mapGetters(["rules"]),
    passwordConfirmationRule() {
      return [
        (value) =>
          !!value || (this.lang == "en" ? "Required" : "Obavezno polje"),
        this.password.new === this.password.newConfirm ||
          (this.lang == "en"
            ? "New passwords must match"
            : "Nove lozinke se moraju poklapati"),
      ];
    },
  },
  methods: {
    resetPassword() {
      if (this.$refs.resetPasswordForm.validate()) {
        var payload = {
          companyId: this.IDcompany,
          oldPassword: this.password.old,
          newPassword: this.password.new
        }
        this.$store.dispatch('changePassword', payload)
      }
    }
  }
}
</script>

<style lang="scss">
.reset-password-container {
  padding: 30px 20px;
  background: $bg2;
}

@media (max-width: 768px) {
  .reset-password-container {
    padding: 20px 10px;
  }
}
</style>